import { createFileRoute } from '@tanstack/react-router'
import { CopilotDashboard } from '@/features/admin/copilot'

export const Route = createFileRoute('/_authenticated/admin/copilot')({
  component: CopilotDashboard,
})
